import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { first } from "rxjs/operators";
import { AuthenticationService } from "src/app/_services";
import { ApiService } from "src/app/api.service";
import { AssistDt1 } from "src/app/shared/models/AssistDt1";
import { AssistDt2 } from "src/app/shared/models/AssistDt2";
import { AssistHdr } from "src/app/shared/models/AssistHdr";
import { CookieTovpil } from "src/app/shared/models/CookieTovpil";
import { ResponseFile } from "src/app/shared/models/ResponseFile";
import { SecurityDocument } from "src/app/shared/models/SecurityDocument";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";
import { UserPreferencesService } from "src/app/utils/user-preferences.service";

@Component({
  selector: "app-guidelines-assist-dt2",
  templateUrl: "./guidelines-assist-dt2.component.html",
  styleUrls: ["./guidelines-assist-dt2.component.scss"],
  providers: [MessageService, ConfirmationService],
})
export class GuidelinesAssistDt2Component implements OnInit {
  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT */
  folderId: string = "DIGITALITEMS";
  itemId: string;
  albumId: string;
  token: string;
  itemDialog: boolean;
  lstItemsTrak: AssistDt2[];
  itemsAlbum: AssistDt1;
  selectedItemsTrak: AssistDt2 = null;
  item: AssistHdr = null;
  security: SecurityDocument;
  responseFile?: ResponseFile;
  sequence: string;
  dnwGroup: string;
  descrip: string;
  link: string;
  seqDt2: string;
  status: string;
  fileName: string;
  imageSrc: string = "";
  showInternatColumns: boolean;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private userPreferencesService: UserPreferencesService,
    private authenticationService: AuthenticationService,
    private translationService: TovpilLanguageService
  ) {
    this.initConfigs();
    this.route.queryParams.subscribe((params) => {
      this.itemId = params.itemId;
      this.albumId = params.albumId;
      this.token = params.token;
      this.dnwGroup = params.dnwGroup;
    });
    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
   * The function initializes form groups for configuration and data, and updates the configuration form
   * with query parameters from the route.
   */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;

    console.debug(
      "guideLinesAssistDT2 - USER PREFERENCES: " +
        JSON.stringify(this.globalUserPreferences, null, 2)
    );
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            // this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  /**
   * The ngOnInit function calls the getSecurity method when the component is initialized.
   */
  ngOnInit(): void {
    this.showInternatColumns = false;
    this.getSecurity();
  }

  /**
   * The function `getSecurity` asynchronously retrieves security data using an API service, then
   * proceeds to fetch translated labels, a guide, and an item list if the security data is
   * successfully obtained.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;
    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences.preferences = data;
    }

    if (securityControl.preferences.levelId == "I") {
      this.showInternatColumns = true;
    }

    await this.getTranslatedLabels();
    await this.listItemsTrackByItemAlbum();
    await this.getItemById();
    await this.getItemsAlbumById();
    this.blocked = false;
  }


  /**
   * The function `listItemsTrackByItemAlbum` retrieves a list of items based on the item and album
   * IDs.
   */
  async listItemsTrackByItemAlbum() {
    const language = this.globalUserPreferences.preferences.language;
    this.lstItemsTrak = [];
    const data = await this.apiService.getAssistDt2ByAssistIdDt1({
      assistId: this.itemId,
      seqDt1: this.albumId,
      language: language,
    });
    this.lstItemsTrak = data;
  }

  /**
   * The `openNew` function resets several properties to null and sets `itemDialog` to true.
   */
  openNew() {
    this.sequence = null;
    this.descrip = null;
    this.fileName = null;
    this.link = null;
    this.seqDt2 = null;
    this.status = null;
    this.selectedItemsTrak = null;
    this.itemDialog = true;
  }

  /**
   * The `hideDialog` function sets `itemDialog` to false, clears `selectedItemsTrak`, and calls
   * `listItemsTrackByItemAlbum`.
   */
  hideDialog() {
    this.itemDialog = false;
    this.selectedItemsTrak = null;
    this.listItemsTrackByItemAlbum();
  }

  /**
   * The function `createUpdateTrack` asynchronously creates or updates a track based on certain
   * conditions.
   */
  async createUpdateTrack() {
    let savedItmTrack: AssistDt2;
    const language = this.globalUserPreferences.preferences.language;
    if (
      this.selectedItemsTrak == null ||
      this.selectedItemsTrak.id.seqDt2 == null
    ) {
      const data = await this.apiService.createAssistDt2({
        id: {
          assistId: this.itemId,
          language: language,
          seqDt1: this.albumId,
          seqDt2: this.seqDt2,
        },
        descrip: this.descrip,
        link: this.link,
        status: "N",
      });
      savedItmTrack = data;
      this.hideDialog();
    } else {
      const data = await this.apiService.updateAssistDt2({
        id: {
          assistId: this.itemId,
          language: language,
          seqDt1: this.albumId,
          seqDt2: this.seqDt2,
        },
        descrip: this.descrip,
        link: this.link,
        status: this.selectedItemsTrak.status,
      });
      savedItmTrack = data;
      this.hideDialog();
    }
  }

  /**
   * The `edit` function in TypeScript is used to asynchronously retrieve data and update specific
   * properties in an object.
   * @param {AssistDt2} doc - The `doc` parameter in the `edit` function is of type `AssistDt2`. It
   * contains properties such as `id`, `descrip`, `link`, and `itemDialog`. The function uses the `id`
   * property of `doc` to fetch data from the `api
   */
  async edit(doc: AssistDt2) {
    this.selectedItemsTrak = null;
    const data = await this.apiService.getAssistDt2ById({
      assistId: doc.id.assistId,
      seqDt1: doc.id.seqDt1,
      seqDt2: doc.id.seqDt2,
    });
    this.selectedItemsTrak = data;
    this.descrip = doc.descrip;
    this.link = doc.link;
    this.seqDt2 = doc.id.seqDt2;
    this.itemDialog = true;
  }

  /**
   * The function `getItemById` asynchronously retrieves an item by its ID using the `apiService` and
   * sets it to the `item` property.
   */
  async getItemById() {
    const language = this.globalUserPreferences.preferences.language;
    const data = await this.apiService.getAssistHdrById({
      assistId: this.itemId,
      language: language,
    });
    this.item = data;
  }

  /**
   * The `removeSelected` function sends a delete request to the API service to remove a selected item
   * and then hides a dialog upon successful completion or logs an error if there is one.
   */
  async removeSelected() {
    const data = await this.apiService.deleteAssistDt2({
      id: {
        assistId: this.selectedItemsTrak.id.assistId,
        seqDt1: this.selectedItemsTrak.id.seqDt1,
        seqDt2: this.selectedItemsTrak.id.seqDt2,
      },
      descrip: this.selectedItemsTrak.descrip,
      link: this.selectedItemsTrak.link,
      status: this.selectedItemsTrak.status,
    });
    await this.hideDialog();
  }

  /**
   * The onClickApprove function updates an AssistDt2 item with a status of "A" and then hides a dialog
   * and lists items by album.
   * @param {AssistDt2} itm - The `onClickApprove` function is an asynchronous function that handles
   * the approval of an item. It takes a parameter `itm` of type `AssistDt2`, which seems to be an
   * object containing information about the item to be approved.
   */
  async onClickApprove(itm: AssistDt2) {
    const language = this.globalUserPreferences.preferences.language;
    const data = await this.apiService.updateAssistDt2({
      id: {
        assistId: itm.id.assistId,
        seqDt1: itm.id.seqDt1,
        seqDt2: itm.id.seqDt2,
        language: language,
      },
      descrip: itm.descrip,
      link: itm.link,
      status: "A",
    });
    await this.hideDialog();
    await this.listItemsTrackByItemAlbum();
  }

  /**
   * The function `disabledEditRules` checks if a given item's link is null or its status is not 'A'
   * and returns a boolean result accordingly.
   * @param {AssistDt2} itm - AssistDt2 object with properties link and status.
   * @returns The function `disabledEditRules` is returning a boolean value, either `true` or `false`,
   * based on the conditions specified in the function.
   */
  disabledEditRules(itm: AssistDt2) {
    let result: boolean = true;
    if (itm.link == null || itm.status != "A") {
      result = false;
    }
    return result;
  }

  /**
   * This async function retrieves items related to a specific album by making an API call with
   * specified parameters.
   */
  async getItemsAlbumById() {
    const language = this.globalUserPreferences.preferences.language;
    const data = await this.apiService.getAssistDt1ById({
      assistId: this.itemId,
      seqDt1: this.albumId,
      language: language,
    });
    this.itemsAlbum = data;
  }

  /**
   * The function `checkDisabledDownload` determines whether the download option should be disabled
   * based on certain conditions.
   * @param {AssistDt2} doc - The function `checkDisabedDownload` takes a parameter `doc` of type
   * `AssistDt2`. The function checks certain conditions related to the `doc` object and returns a
   * boolean value based on those conditions.
   * @returns The function `checkDisabedDownload` is returning a boolean value based on the conditions
   * specified in the code. The return value will be either `true` or `false` depending on the values
   * of `this.showInternatColumns`, `doc.status`, and `doc.link`.
   */
  checkDisabedDownload(doc: AssistDt2) {
    let result = true;
    if (this.showInternatColumns) {
      result = false;
    } else {
      if (doc.status == "A" && doc.link != null) {
        result = false;
      }
    }
    return result;
  }

  /**
   * The function `openLink` opens a link in a new tab based on certain conditions.
   * @param {AssistDt2} aDt2 - `aDt2` is an object representing some data related to a link. It likely
   * contains properties such as `status` and `link`.
   */
  openLink(aDt2: AssistDt2) {
    if (
      this.showInternatColumns ||
      (!this.showInternatColumns && aDt2.status == "A")
    ) {
      window.open(aDt2.link, "_blank");
    }
  }

  /**
   * The function `getTranslatedLabels` asynchronously retrieves translated labels based on user
   * preferences and handles any errors that occur.
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();

      // await this.getLanguages();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  /**
   * The `goBack` function navigates to a specific route with query parameters in a TypeScript Angular
   * application.
   */
  goBack() {
    this.router.navigate(["commons/guideLinesAssistDt1"], {
      queryParams: {
        itemId: this.itemId,
        token: this.token,
        dnwGroup: this.dnwGroup,
      },
    });
  }
}
